import { enviroment } from "../../enviroment";
import { PageQuery } from "./pageQuery";

/**
 * The ONE place that decides which query the "all vendors" consumers send to
 * GET organizations/Vendors (flag REACT_APP_VENDOR_LIST_PAGE_SIZE_ENABLED,
 * ANALYSE-ADMIN-STALL-PRISIMPORT-2026-09-27 rang 1).
 *
 * Today (flag off) two shapes exist:
 *  - LEGACY_ALL_VENDORS_QUERY (= logo-editor.screen's getAllQuery): size 0 is
 *    dropped by toQueryParam -> "?pageIndex=1" -> the API's DEFAULT page of
 *    25 rows, name-descending. Used by useCustomerAndVendors (design list's
 *    admin filter + the gates of logo/order list, logo editor, imports), the
 *    login/copy prefetches and customer-create. (The sheet-size page has its
 *    own complete list since #875 - useAllVendorsUnpaged, pageSize=0 - and
 *    is NOT routed through here; the flag only adds all=true to that call.)
 *  - LEGACY_VENDOR_PICKER_QUERY: "?pageSize=10000&pageIndex=1" -> really all
 *    vendors, each with the full Children/Parent/Commission graph (the act-as
 *    and logo-sharing pickers; the 120-180 s responses).
 *
 * Flag on, every shape gets all=true (the API's admin branch,
 * VendorListAdminPagedEnabled, answers it with the whole lean list DTO), but
 * each KEEPS its page size, because an API WITHOUT that branch (API flag off,
 * e.g. an API rollback while the FE flag stays on) ignores `all`:
 *  - ALL_VENDORS_LOOKUP_QUERY "?pageIndex=1&all=true": API off -> the default
 *    page of 25 = exactly today (deliberately NOT given pageSize=10000: with
 *    the API off that would turn the login prefetch and every list gate into
 *    today's 120-180 s full-graph call). API on -> all rows, lean.
 *  - ALL_VENDORS_PICKER_QUERY "?pageSize=10000&pageIndex=1&all=true": API off
 *    -> pageSize=10000 is honoured = every vendor, exactly today; API on ->
 *    all rows, lean. Without pageSize the pickers would silently drop to the
 *    first 25 of ~129 vendors whenever the API flag is off.
 *
 * Cache keys (useAllVendors/prefetchAllVendors = ["all-vendors", query]):
 *  - off: ["all-vendors", "?pageIndex=1"] (lookup) and
 *         ["all-vendors", "?pageSize=10000&pageIndex=1"] (pickers)
 *  - on:  ["all-vendors", "?pageIndex=1&all=true"] (lookup; warmed by the
 *         login/copy prefetches) and
 *         ["all-vendors", "?pageSize=10000&pageIndex=1&all=true"] (pickers)
 * i.e. the same TWO keys as today (never an extra call), both under the
 * "all-vendors" prefix that invalidateHelperOrgLists invalidates. The admin
 * vendor list screen is NOT routed through here: it always sends its real
 * page (pageSize=24/48/96).
 *
 * Both are functions (not module constants) so the flag is read per call.
 */
export const LEGACY_ALL_VENDORS_QUERY = {
  page: { index: 1, size: 0 },
} as PageQuery;

export const LEGACY_VENDOR_PICKER_QUERY = {
  page: { index: 1, size: 10000 },
} as PageQuery;

export const ALL_VENDORS_LOOKUP_QUERY = {
  page: { index: 1, size: 0 },
  all: true,
} as PageQuery;

export const ALL_VENDORS_PICKER_QUERY = {
  page: { index: 1, size: 10000 },
  all: true,
} as PageQuery;

/** For today's getAllQuery callers (helper list / lookup id -> name). */
export function vendorLookupQuery(): PageQuery {
  return enviroment.vendorListPageSizeEnabled
    ? ALL_VENDORS_LOOKUP_QUERY
    : LEGACY_ALL_VENDORS_QUERY;
}

/** For today's pageSize=10000 callers (act-as / logo-sharing pickers). */
export function vendorPickerQuery(): PageQuery {
  return enviroment.vendorListPageSizeEnabled
    ? ALL_VENDORS_PICKER_QUERY
    : LEGACY_VENDOR_PICKER_QUERY;
}
